"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6705],{

/***/ 86705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _StroykaSlick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79693);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54407);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69587);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75681);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63385);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _services_breakpoints__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33794);
/* provided dependency */ var process = __webpack_require__(34155);

















var ProductGallery = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(ProductGallery, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(ProductGallery);
    function ProductGallery(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, ProductGallery);
        var _this;
        _this = _super.call(this, props);
        /** @var {Promise} */ _this.createGallery = null;
        _this.imagesRefs = [];
        _this.unmounted = false;
        //@ts-ignore
        _this.handleFeaturedClick = function(event, index) {
            event.preventDefault();
            //@ts-ignore
            var layout = _this.props.layout;
            if (!_this.createGallery || layout === "quickview") {
                return;
            }
            _this.openPhotoswipe(index);
        };
        //@ts-ignore
        _this.handleThumbnailClick = function(index) {
            //@ts-ignore
            var transition = _this.state.transition;
            if (transition) {
                return;
            }
            _this.setState(function() {
                return {
                    currentIndex: index
                };
            });
            //@ts-ignore
            if (_this.slickFeaturedRef) {
                //@ts-ignore
                _this.slickFeaturedRef.slickGoTo(_this.getIndexDependOnDir(index));
            }
        };
        //@ts-ignore
        _this.handleFeaturedBeforeChange = function(oldIndex, newIndex) {
            _this.setState(function() {
                return {
                    currentIndex: _this.getIndexDependOnDir(newIndex),
                    transition: true
                };
            });
        };
        //@ts-ignore
        _this.handleFeaturedAfterChange = function(index) {
            _this.setState(function() {
                return {
                    currentIndex: _this.getIndexDependOnDir(index),
                    transition: false
                };
            });
        };
        _this.handleZoomButtonClick = function() {
            //@ts-ignore
            var currentIndex = _this.state.currentIndex;
            _this.openPhotoswipe(currentIndex);
        };
        //@ts-ignore
        _this.setSlickFeaturedRef = function(ref) {
            //@ts-ignore
            _this.slickFeaturedRef = ref;
        };
        _this.state = {
            currentIndex: 0,
            transition: false
        };
        return _this;
    }
    var _proto = ProductGallery.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        //@ts-ignore
        this.createGallery = Promise.all(/* import() */[__webpack_require__.e(2025), __webpack_require__.e(7994)]).then(__webpack_require__.bind(__webpack_require__, 2118)).then(function(module) {
            return module.createGallery;
        });
        setTimeout(function() {
            _this.setState(function() {
                return {
                    transition: false
                };
            });
        }, 0);
    };
    //@ts-ignore
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this = this;
        var prevLocale = prevProps.locale;
        //@ts-ignore
        var _prevLocale = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[prevLocale], prevDirection = _prevLocale.direction;
        //@ts-ignore
        var _props = this.props, currLocale = _props.locale;
        //@ts-ignore
        var _currLocale = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[currLocale], currDirection = _currLocale.direction;
        if (currDirection !== prevDirection) {
            setTimeout(function() {
                _this.setState(function() {
                    return {
                        transition: false
                    };
                });
            }, 0);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.gallery) {
            this.gallery.destroy();
        }
        this.unmounted = true;
    };
    //@ts-ignore
    _proto.getIndexDependOnDir = function getIndexDependOnDir(index) {
        //@ts-ignore
        var _props = this.props, images = _props.images, locale = _props.locale;
        //@ts-ignore
        var direction = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale].direction;
        // we need to invert index id direction === 'rtl' due to react-slick bug
        if (direction === "rtl") {
            return images.length - 1 - index;
        }
        return index;
    };
    //@ts-ignore
    _proto.openPhotoswipe = function openPhotoswipe(index) {
        var _this = this;
        //@ts-ignore
        var _props = this.props, images = _props.images, locale = _props.locale;
        //@ts-ignore
        var direction = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale].direction;
        var items = this.imagesRefs.map(function(tag, index) {
            //@ts-ignore
            var width = parseFloat(tag.dataset.width) || tag.naturalWidth + 150;
            //@ts-ignore
            var height = parseFloat(tag.dataset.height) || tag.naturalHeight + 150;
            var storeDomain = process.env.storeDomain;
            var image = images[index].large_image_url;
            return {
                src: image,
                msrc: image,
                w: width,
                h: height
            };
        });
        if (direction === "rtl") {
            items.reverse();
        }
        var options = {
            //@ts-ignore
            getThumbBoundsFn: function(index) {
                var dirDependentIndex = _this.getIndexDependOnDir(index);
                if (!_this.imagesRefs[dirDependentIndex]) {
                    return null;
                }
                var tag = _this.imagesRefs[dirDependentIndex];
                //@ts-ignore
                var width = tag.naturalWidth;
                //@ts-ignore
                var height = tag.naturalHeight;
                //@ts-ignore
                var rect = tag.getBoundingClientRect();
                var ration = Math.min(rect.width / width, rect.height / height);
                var fitWidth = width * ration;
                var fitHeight = height * ration;
                return {
                    x: rect.left + (rect.width - fitWidth) / 2 + window.pageXOffset,
                    y: rect.top + (rect.height - fitHeight) / 2 + window.pageYOffset,
                    w: fitWidth
                };
            },
            index: this.getIndexDependOnDir(index),
            bgOpacity: 0.9,
            history: false
        };
        //@ts-ignore
        this.createGallery.then(function(createGallery) {
            /*FIXME commented for showing zoom effect in products inner page images// open after fixing this issue*/ // if (this.unmounted) {
            //     return;
            // }
            _this.gallery = createGallery(items, options);
            _this.gallery.listen("beforeChange", function() {
                //@ts-ignore
                if (_this.gallery && _this.slickFeaturedRef) {
                    //@ts-ignore
                    _this.slickFeaturedRef.slickGoTo(_this.gallery.getCurrentIndex(), true);
                }
            });
            _this.gallery.listen("destroy", function() {
                _this.gallery = null;
            });
            _this.gallery.init();
        });
    };
    _proto.render = function render() {
        var _this = this;
        var dbName = process.env.domainName;
        //@ts-ignore
        var _props = this.props, layout = _props.layout, images = _props.images;
        //@ts-ignore
        var currentIndex = this.state.currentIndex;
        //@ts-ignore
        var featured = images.map(function(image, index) {
            var realImagePath = (0,_services_utils__WEBPACK_IMPORTED_MODULE_6__/* .isDefaultImage */ .QO)(image.path) ? image.path : image.original_image_url;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image--location--gallery"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer",
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image__body"]),
                    href: realImagePath,
                    onClick: function(event) {
                        return _this.handleFeaturedClick(event, index);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "product-image",
                        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image__img"]),
                        src: realImagePath,
                        ref: function(element) {
                            //@ts-ignore
                            _this.imagesRefs[index] = element;
                        }
                    })
                })
            }, index);
        });
        //@ts-ignore
        var thumbnails = images.map(function(image, index) {
            var realImagePath = (0,_services_utils__WEBPACK_IMPORTED_MODULE_6__/* .isDefaultImage */ .QO)(image.path) ? (0,_helper__WEBPACK_IMPORTED_MODULE_7__/* .domainUrl */ .HJ)("".concat(dbName).concat(image.path)) : (0,_helper__WEBPACK_IMPORTED_MODULE_7__/* .domainUrl */ .HJ)("".concat(dbName, "/storage/").concat(image.path));
            var classes = classnames__WEBPACK_IMPORTED_MODULE_3___default()("".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-gallery__carousel-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image"])), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-gallery__carousel-item--active"]), index === currentIndex));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: function() {
                    return _this.handleThumbnailClick(index);
                },
                className: classes,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["small-img-car_fms"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                        src: realImagePath,
                        alt: "thumbnail product",
                        placeholder: "blur",
                        layout: "fill",
                        priority: true,
                        blurDataURL: "/zega/blur1.webp"
                    })
                })
            }, index);
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default().product__gallery),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-gallery"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-gallery__featured"]),
                        children: [
                            layout !== "quickview" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-gallery__zoom"]),
                                onClick: this.handleZoomButtonClick,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_5__/* .ZoomIn24Svg */ .Jx, {})
                            }),
                            //@ts-ignore
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StroykaSlick__WEBPACK_IMPORTED_MODULE_2__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                                ref: this.setSlickFeaturedRef
                            }, _services_breakpoints__WEBPACK_IMPORTED_MODULE_9__/* .slickSettingsFeatured */ .J3), {
                                beforeChange: this.handleFeaturedBeforeChange,
                                afterChange: this.handleFeaturedAfterChange,
                                children: featured
                            }))
                        ]
                    }),
                    //@ts-ignore
                    !this.props.ups && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-gallery__carousel"]), " carousel-parent"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StroykaSlick__WEBPACK_IMPORTED_MODULE_2__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, _services_breakpoints__WEBPACK_IMPORTED_MODULE_9__/* .slickSettingsThumbnails */ .Dy[layout]), {
                            children: thumbnails
                        }))
                    })
                ]
            })
        });
    };
    return ProductGallery;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ProductGallery));


/***/ }),

/***/ 79693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26628);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54407);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46066);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_10__);














var StroykaSlickBase = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(StroykaSlickBase, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(StroykaSlickBase);
    function StroykaSlickBase(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, StroykaSlickBase);
        var _this;
        _this = _super.call(this, props);
        _this.unsubscribeMedias = function() {};
        _this.originalSlickNext = function() {};
        _this.originalSlickPrev = function() {};
        _this.setRef = function(ref) {
            _this.element = ref;
        };
        _this.onMousedown = function(event) {
            var downX = event.screenX;
            var downY = event.screenY;
            var onMousemove = function(moveEvent) {
                var preventClick = _this.state.preventClick;
                if (preventClick) {
                    return;
                }
                var distance = Math.sqrt(Math.pow(Math.abs(downX - moveEvent.screenX), 2) + Math.pow(Math.abs(downY - moveEvent.screenY), 2));
                if (moveEvent.cancelable && distance > 3) {
                    moveEvent.preventDefault();
                }
                if (distance > 15) {
                    _this.setState({
                        preventClick: true
                    });
                }
            };
            var onMouseup = function() {
                _this.setState({
                    preventClick: false
                });
                document.removeEventListener("mousemove", onMousemove);
                document.removeEventListener("mouseup", onMouseup);
            };
            document.addEventListener("mousemove", onMousemove);
            document.addEventListener("mouseup", onMouseup);
        };
        _this.beforeChange = function(oldIndex, newIndex) {
            // @ts-ignore
            var beforeChange = _this.props.beforeChange;
            if (beforeChange) {
                beforeChange(oldIndex, newIndex);
            }
            setTimeout(function() {
                _this.setState({
                    activeSlides: _this.getActiveSlides(newIndex)
                });
            }, 0);
        };
        _this.setSlickRef = function(ref) {
            // @ts-ignore
            var _$forwardRef = _this.props.forwardRef;
            if (_$forwardRef) {
                _$forwardRef(ref);
            }
            if (ref && ref !== _this.slickRef) {
                _this.originalSlickNext = ref.slickNext;
                _this.originalSlickPrev = ref.slickPrev;
                ref.slickNext = _this.slickNext;
                ref.slickPrev = _this.slickPrev;
            }
            // @ts-ignore
            _this.slickRef = ref;
        };
        _this.slickNext = function() {
            // @ts-ignore
            var locale = _this.props.locale;
            // @ts-ignore
            var direction = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale].direction;
            if (direction === "rtl") {
                _this.originalSlickPrev();
            } else {
                _this.originalSlickNext();
            }
        };
        _this.slickPrev = function() {
            // @ts-ignore
            var locale = _this.props.locale;
            // @ts-ignore
            var direction = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale].direction;
            if (direction === "rtl") {
                _this.originalSlickNext();
            } else {
                _this.originalSlickPrev();
            }
        };
        _this.state = {
            preventClick: false,
            activeSlides: _this.getActiveSlides(_this.getStartPosition()),
            slidesToShow: null
        };
        return _this;
    }
    var _proto = StroykaSlickBase.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (!this.element) {
            return;
        }
        this.element.addEventListener("mousedown", this.onMousedown);
        if (this.slickRef) {
            this.slickRef.slickGoTo(this.getStartPosition(), true);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this = this;
        // const {locale: prevLocale, children: prevChildren} = prevProps;
        var prevChildren = prevProps.children;
        var prevLocale = "en";
        // @ts-ignore
        var language = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[prevLocale];
        var prevDirection = language ? language.direction : "ltr";
        // @ts-ignore
        // const {locale: currLocale, children: currChildren} = this.props;
        var _props = this.props, currChildren = _props.children;
        var currLocale = "en";
        // @ts-ignore
        var _currLocale = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[currLocale], currDirection = _currLocale.direction;
        if (currDirection !== prevDirection && this.slickRef) {
            this.slickRef.slickGoTo(this.getStartPosition(), true);
        }
        if (currChildren !== prevChildren) {
            setTimeout(function() {
                _this.setState({
                    activeSlides: _this.getActiveSlides(_this.getStartPosition())
                });
            }, 0);
        }
        var prevResponsive = prevProps.responsive;
        // @ts-ignore
        var _props1 = this.props, currResponsive = _props1.responsive;
        if (currResponsive !== prevResponsive) {
            this.unsubscribeMedias();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeMedias();
        if (!this.element) {
            return;
        }
        this.element.removeEventListener("mousedown", this.onMousedown);
    };
    _proto.getSlidesCount = function getSlidesCount() {
        //@ts-ignore
        return react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(this.props.children).length;
    };
    _proto.getStartPosition = function getStartPosition() {
        // @ts-ignore
        var infinite = this.props.infinite;
        // @ts-ignore
        var _props = this.props, _locale = _props.locale, locale = _locale === void 0 ? "en" : _locale;
        // @ts-ignore
        var language = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale];
        var direction = language ? language.direction : "ltr";
        infinite = infinite === true || infinite === undefined;
        if (direction === "ltr") {
            return 0;
        }
        var slidesToShow = null;
        // const slidesCount = 3
        var slidesCount = this.getSlidesCount();
        if (!infinite) {
            // @ts-ignore
            return Math.max(0, slidesCount - slidesToShow);
        }
        // @ts-ignore
        return (Math.ceil(slidesCount / slidesToShow) - 1) * slidesToShow;
    };
    // @ts-ignore
    _proto.getActiveSlides = function getActiveSlides(currentIndex) {
        var slidesToShow = null;
        var activeSlides = [];
        var slidesCount = this.getSlidesCount();
        var firstSlide = Math.max(0, // @ts-ignore
        Math.min(slidesCount - slidesToShow, currentIndex));
        // @ts-ignore
        var lastSlide = Math.min(slidesCount, firstSlide + slidesToShow);
        for(var i = firstSlide; i < lastSlide; i += 1){
            activeSlides.push(i);
        }
        return activeSlides;
    };
    _proto.getSlidesToShow = function getSlidesToShow() {
        // @ts-ignore
        var _props = this.props, responsive = _props.responsive, slidesToShow = _props.slidesToShow;
        var result = slidesToShow || 1;
        if (responsive) {
            // @ts-ignore
            responsive.forEach(function(options) {
                var matches = matchMedia("(max-width: ".concat(options.breakpoint, "px)")).matches;
                if (matches && options.settings.slidesToShow) {
                    result = options.settings.slidesToShow;
                }
            });
        }
        return result;
    };
    _proto.createMedias = function createMedias() {
        var _this = this;
        // @ts-ignore
        var _props = this.props, responsive = _props.responsive, slidesToShow = _props.slidesToShow;
        if (responsive && responsive.length > 0) {
            // @ts-ignore
            var subscriptions = [];
            var createMedia = function(query, slidesToShow) {
                var media = matchMedia(query);
                var onChange = function() {
                    var matches = media.matches;
                    if (matches && slidesToShow) {
                        _this.setState(function() {
                            return {
                                slidesToShow: slidesToShow
                            };
                        });
                    }
                };
                if (media.addEventListener) {
                    media.addEventListener("change", onChange);
                } else {
                    media.addListener(onChange);
                }
                subscriptions.push(function() {
                    if (media.removeEventListener) {
                        media.removeEventListener("change", onChange);
                    } else {
                        media.removeListener(onChange);
                    }
                });
            };
            createMedia("(min-width: ".concat(responsive[0].breakpoint, ".02px)"), slidesToShow || 1);
            responsive.forEach(function(options, index) {
                var query = [
                    "(max-width: ".concat(options.breakpoint, "px)")
                ];
                if (responsive.length - 1 !== index) {
                    query.push("(min-width: ".concat(responsive[index + 1].breakpoint, ".02px)"));
                }
                createMedia(query.join(" and "), options.settings.slidesToShow);
            });
            this.unsubscribeMedias = function() {
                subscriptions.forEach(function(x) {
                    return x();
                });
            };
        }
    };
    _proto.render = function render() {
        // @ts-ignore
        var _props = this.props, children = _props.children, _$forwardRef = _props.forwardRef, locale = _props.locale, beforeChange = _props.beforeChange, autoplay = _props.autoplay, autoplaySpeed = _props.autoplaySpeed, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_props, [
            "children",
            "forwardRef",
            "locale",
            "beforeChange",
            "autoplay",
            "autoplaySpeed"
        ]);
        var _state = this.state, preventClick = _state.preventClick, activeSlides = _state.activeSlides, slidesToShow = _state.slidesToShow;
        // @ts-ignore
        var language = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale];
        var direction = language ? language.direction : "ltr";
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["slick-prevent-click"]), preventClick && (_shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["slick-prevent-click--active"]));
        var reversedChildren = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
        if (direction === "rtl") {
            reversedChildren = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(children);
            reversedChildren.reverse();
        }
        reversedChildren.map(function(slide, index) {
            var slideClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()(activeSlides.includes(index) && (_shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["correct-slick-active"]));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dir: direction,
                className: slideClasses,
                children: slide
            }, index);
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes,
            onMouseDown: this.onMousedown,
            ref: this.setRef,
            style: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, otherProps), {
                autoplay: autoplay,
                rtl: false,
                beforeChange: this.beforeChange,
                autoplaySpeed: autoplaySpeed,
                infinite: // @ts-ignore
                otherProps.infinite && react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children) > slidesToShow,
                // @ts-ignore
                ref: this.setSlickRef,
                children: reversedChildren
            }))
        });
    };
    return StroykaSlickBase;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var mapStateToProps = function(state) {
    return {
        locale: state.locale.code
    };
};
var StroykaSlick = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps)(StroykaSlickBase);
// @ts-ignore
// eslint-disable-next-line react/display-name
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StroykaSlick, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        forwardRef: ref
    }, props));
}));


/***/ }),

/***/ 54407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// application
var enMessages = __webpack_require__(82742);
var ruMessages = __webpack_require__(16495);
var hyMessages = __webpack_require__(24447);
/* harmony default export */ __webpack_exports__["Z"] = ({
    en: {
        messages: enMessages,
        direction: "ltr"
    },
    ru: {
        messages: ruMessages,
        direction: "ltr"
    },
    hy: {
        messages: hyMessages,
        direction: "ltr"
    }
});


/***/ }),

/***/ 33794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ slickSettingsThumbnails; },
/* harmony export */   "J3": function() { return /* binding */ slickSettingsFeatured; },
/* harmony export */   "e0": function() { return /* binding */ BlockProductCarouselSlickSettings; },
/* harmony export */   "vG": function() { return /* binding */ slickSettings; }
/* harmony export */ });
/*** BlockSlideShow***/ var slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1
};
/*** ProductGallery  settings ***/ var slickSettingsFeatured = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1
};
var slickSettingsThumbnails = {
    standard: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 379,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    },
    sidebar: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 379,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    },
    columnar: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 379,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    },
    quickview: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 379,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    }
};
/*** BlockProductCarousel ***/ var BlockProductCarouselSlickSettings = {
    "grid-4": {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, 
        ]
    },
    "grid-4-sm": {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 474,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, 
        ]
    },
    "grid-5": {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, 
        ]
    },
    horizontal: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, 
        ]
    }
};


/***/ }),

/***/ 82742:
/***/ (function(module) {

module.exports = {};

/***/ }),

/***/ 24447:
/***/ (function(module) {

module.exports = {};

/***/ }),

/***/ 16495:
/***/ (function(module) {

module.exports = JSON.parse('{"topBar.phone1":"374 93 99-10-93","topBar.phone2":"+374 10 35-11-00","topBar.storeLocation":"Магазин","topBar.trackOrder":"Статус заказа","topBar.blog":"Блог","topBar.myAccount":"Аккаунт","topBar.currency":"Валюта","topBar.language":"Язык","topBar.login":"Մուտք","topBar.forgot":"Մոռացե՞լ եք գաղտնաբառը","header.phoneLabel":"Звонок бесплатный","header.phone":"(800) 060-0730"}');

/***/ })

}]);